<template>
  <div class="avatar">
    <div
      v-if="hasImage"
      class="image"
      :style="computedImageStyle"
    />

    <icon v-else name="person" />
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    imageUrl: String,
    email: String,
  },

  computed: {
    hasImage() {
      return Boolean(this.imageUrl);
    },

    computedImageStyle() {
      return {
        backgroundImage: `url(${this.imageUrl})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.avatar {
  @include circle(var(--avatar-size, 45px));

  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  background-color: $color-gray-6;
  color: $color-gray-1;
}

.image {
  background-size: cover;
  background-position: center center;
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
